import { Configuration as ConfigurationAccounts } from '@core/api/generated/accounts/v1';
import { Configuration as ConfigurationInvoices } from '@core/api/generated/invoices/v1';
import { environment } from '@environments/environment';
import { MICROSERVICES } from '@shared/constants/microservices';

//Remove if no needed
export const ACCOUNTS_API_CONFIG = new ConfigurationAccounts({
    basePath: `${environment.url}${MICROSERVICES.accounts}`,
});

export const INVOICES_API_CONFIG = new ConfigurationInvoices({
    basePath: `${environment.url}${MICROSERVICES.invoices}`,
});

// export const VEHICLES_API_CONFIG = new ConfigurationVehicles({
//     basePath: `${environment.url}${MICROSERVICES.vehicles}`,
// });

// export const PAYMENTS_API_CONFIG = new ConfigurationPayments({
//     basePath: `${environment.url}${MICROSERVICES.payments}`,
// });

// export const TOLLING_API_CONFIG = new ConfigurationTolling({
//     basePath: `${environment.url}${MICROSERVICES.tolling}`,
// });
